(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (function () {
    var productTitles = {};
    var initialized = false;

    function init() {
      if (initialized) return;
      var inputs = document.querySelectorAll('.scx-col-search__input');
      if (!inputs.length) return;
      initialized = true;

      // Load all product titles via Shopify API
      var match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
      if (match) {
        fetch('/collections/' + match[1] + '/products.json?limit=250')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            (data.products || []).forEach(function (p) {
              productTitles[String(p.id)] = p.title.toLowerCase();
            });
          })
          .catch(function () {});
      }

      inputs.forEach(function (input) {
        // Prevent form submission — we handle filtering client-side
        var form = input.closest('form');
        if (form) {
          form.addEventListener('submit', function (e) {
            e.preventDefault();
            syncAndFilter(input);
          });
        }

        // Filter on every keystroke
        input.addEventListener('input', function () {
          syncAndFilter(input);
        });

        // Enter key
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            syncAndFilter(input);
          }
        });
      });

      // Icon button click — find sibling input inside same wrapper
      var iconBtns = document.querySelectorAll('.scx-col-search__icon-btn');
      iconBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var wrapper = btn.closest('.scx-col-search');
          var siblingInput = wrapper && wrapper.querySelector('.scx-col-search__input');
          if (siblingInput) {
            siblingInput.focus();
            syncAndFilter(siblingInput);
          }
        });
      });
    }

    function syncAndFilter(changedInput) {
      var val = changedInput.value;
      // Keep all inputs in sync
      document.querySelectorAll('.scx-col-search__input').forEach(function (inp) {
        if (inp !== changedInput) inp.value = val;
      });
      filterProducts(val);
    }

    function filterProducts(rawTerm) {
      var term = rawTerm.toLowerCase().trim();
      var items = document.querySelectorAll('.product-grid__item');
      var visible = 0;

      items.forEach(function (item) {
        var id = item.dataset.productId || '';
        var title = productTitles[id] || getFallbackTitle(item);
        var show = !term || title.includes(term);
        item.style.display = show ? '' : 'none';
        if (show) visible++;
      });

      updateNoResults(visible, rawTerm.trim());
    }

    function getFallbackTitle(item) {
      var el = item.querySelector('a[href*="/products/"], h2, h3, [class*="title"]');
      return el ? el.textContent.trim().toLowerCase() : '';
    }

    function updateNoResults(visible, term) {
      var msg = document.getElementById('scx-no-results-msg');
      if (!msg) {
        msg = document.createElement('p');
        msg.id = 'scx-no-results-msg';
        msg.className = 'scx-col-search__no-results';
        var grid = document.querySelector('.product-grid__list, ul.product-grid');
        if (grid) {
          grid.parentNode.insertBefore(msg, grid.nextSibling);
        } else {
          var wrapper = document.querySelector('.product-grid, .collection-wrapper');
          if (wrapper) wrapper.appendChild(msg);
        }
      }

      if (visible === 0 && term) {
        msg.textContent = 'לא נמצאו מוצרים בשם “' + term + '”';
        msg.removeAttribute('hidden');
      } else {
        msg.setAttribute('hidden', '');
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 200); });
    } else {
      setTimeout(init, 200);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
